import axios from "axios";
import { GetAuthToken } from "rj-server-auth-token";
import Cookies from "js-cookie";
import { removeAllCookie } from "../../utils/loginOut";

const seriveFactory = function (opt, errCallBack) {
  let Axios = axios.create(opt);
  Axios.interceptors.request.use(
    (config) => {
      config.headers["web-sign-server-auth"] = GetAuthToken({
        sysId: "ae0eed67701b458c8967b4d34207d011",
        accessKeySecret: "300F358EEB9E4CE2A2B1D15EE4030C4B",
      });
      config.headers["language"] =
        window.localStorage.getItem("language") || "en";
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  // http响应拦截器
  Axios.interceptors.response.use(
    (res) => {
      //   let json = res.data;
      //   if (json && json.status !== '200') {
      //     Object.prototype.toString.call(errCallBack) === '[object Function]' && errCallBack(json);
      //   }
      //   return res;
      // },
      // error => {
      //   Object.prototype.toString.call(errCallBack) === '[object Function]' && errCallBack({}, error);
      //   return Promise.reject(error);
      // }

      if (res.data.status === "88888") {
        // Cookies.remove('ruijienetworks_user_credentials', { domain: 'ruijienetworks.com' });
        // Cookies.remove('ruijienetworks_sso_credentials', { domain: 'ruijienetworks.com' });
        removeAllCookie();

        // window.location.href = `https://www.ruijienetworks.com/login.aspx?r=${window.location.href}`;
        // window.location.href = `https://sid-uat.ruijie.com.cn/login?service=http://wpcuat.ruijie.com.cn/login`;
        if(window._env_.NODE_ENV === "pro") {
          window.location.href = `https://account.ruijie.com?r=${encodeURIComponent(
            window.location.href
          )}`;
        } else {
          window.location.href = `https://account-uat.ruijie.com?r=${encodeURIComponent(
            window.location.href
          )}`;
        }

        return;
      }
      if (res.data.status === "403") {
        window.location.href = "error403";
        return;
      }
      return res;
    }
    //   if (res.data.status === '401') {
    //     if (window._env_.NODE_ENV === 'pro') {
    //       window.location.href = `https://www.ruijienetworks.com/login.aspx?r=${window.location.href}`;
    //       return;
    //     } else {
    //       // 正式环境
    //       window.location.href = 'ChangeUser';
    //       returnimport axios from 'axios';
    // const seriveFactory = function (opt, errCallBack) {
    //   let Axios = axios.create(opt);
    //   Axios.interceptors.request.use(
    //     config => {
    //       // if (config.method === 'get') {
    //       //   if (config.params) {
    //       //     config.params._v = Math.random();
    //       //   } else {
    //       //     config.params = {
    //       //       _v: Math.random()
    //       //     };
    //       //   }
    //       // }
    //       config.headers['language'] = window.localStorage.getItem('language') || 'en';
    //       return config;
    //     },
    //     error => {
    //       return Promise.reject(error);
    //     }
    //   );
    //   // http响应拦截器
    //   Axios.interceptors.response.use(res => {
    //   //   let json = res.data;
    //   //   if (json && json.status !== '200') {
    //   //     Object.prototype.toString.call(errCallBack) === '[object Function]' && errCallBack(json);
    //   //   }
    //   //   return res;
    //   // },
    //   // error => {
    //   //   Object.prototype.toString.call(errCallBack) === '[object Function]' && errCallBack({}, error);
    //   //   return Promise.reject(error);
    //   // }
    //
    //     if (res.data.status === '88888') {
    //       //window.location.href = `https://www.ruijienetworks.com/login.aspx?r=${window.location.href}`;
    //       // window.location.href = `https://sid-uat.ruijie.com.cn/login?service=http://wpcuat.ruijie.com.cn/login`;
    //       return;
    //       // 正式环境
    //       // window.location.href = 'ChangeUser';
    //       // return;
    //     }
    //     return res;
    //   }
    //   //   if (res.data.status === '401') {
    //   //     if (window._env_.NODE_ENV === 'pro') {
    //   //       window.location.href = `https://www.ruijienetworks.com/login.aspx?r=${window.location.href}`;
    //   //       return;
    //   //     } else {
    //   //       // 正式环境
    //   //       window.location.href = 'ChangeUser';
    //   //       return;
    //   //     }
    //   //   }
    //   //   return res;
    //   // }
    //   );
    //   return Axios;
    // };
    // export default seriveFactory;
    //     }
    //   }
    //   return res;
    // }
  );
  return Axios;
};
export default seriveFactory;
